
const digest = 'b06b3ac63fbd391ea4471b69b1968015fea615c0b3417fc12cf0c97dab79e504';
const classes = {"showLine":"_showLine_1ujed_1","showBox":"_showBox_1ujed_18"};
const css = `._showLine_1ujed_1 {
  padding-left: 20px;
  margin-left: 10px;
  padding-bottom: 20px;
  position: relative;
}
._showLine_1ujed_1::before {
  content: "";
  width: 20px;
  height: calc(100% - 15px);
  background: transparent;
  border-left: 1px solid #e2e5ed;
  border-bottom: 1px solid #e2e5ed;
  position: absolute;
  left: 0;
}

._showBox_1ujed_18 {
  position: relative;
  padding: 20px;
  border: 1px solid #e2e5ed;
  margin-bottom: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  